import { createContext, useContext, useState, useEffect, useMemo } from 'react';
import { useAuthActions } from './auth/useAuthActions';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [orders, setOrders] = useState([]);
  const [addresses, setAddresses] = useState([]);
  const [loading, setLoading] = useState(true);

  const actions = useAuthActions({ setUser, setIsAuthenticated, setOrders, setAddresses });

  // Restore only an explicitly established login session. A refresh cookie by
  // itself must never sign a visitor in automatically.
  useEffect(() => {
    const token = localStorage.getItem('bookscape_token');
    if (!token) {
      setUser(null);
      setIsAuthenticated(false);
      setLoading(false);
      return;
    }

    // /auth/me verifies the stored access token and loads the real DB user.
    actions
      .initFromToken()
      .catch(() => {
        localStorage.removeItem('bookscape_token');
        setUser(null);
        setIsAuthenticated(false);
      })
      .finally(() => setLoading(false));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const value = useMemo(
    () => ({ user, isAuthenticated, orders, addresses, ...actions }),
    [user, isAuthenticated, orders, addresses, actions]
  );

  if (loading) return null;

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
